import { Instagram, Phone, MapPin, ArrowLeft } from 'lucide-react'
import LogoMark from '../common/Logo'
import Button from '../common/Button'

const Footer = () => {
  const quickLinks = [
    { label: 'درباره من', href: '#about' },
    { label: 'گالری', href: '#portfolio' },
    { label: 'دوره‌های آموزشی', href: '#courses' },
    { label: 'مشاوره', href: '#consultation' },
  ]

  return (
    <footer className="bg-gray-900 text-gray-300 mt-0">
      {/* CTA band */}
      <div className="border-b border-white/10">
        <div className="container-custom py-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <h2 className="font-display text-3xl md:text-4xl text-white mb-3">
              دست‌های شما شایسته کاری درخشان است
            </h2>
            <p className="text-gray-400 leading-8">
              یک گفت‌وگوی کوتاه، نقطهٔ شروع مسیر حرفه‌ای شماست.
            </p>
          </div>
          <Button variant="luxury" size="lg" href="#consultation" className="shrink-0">
            رزرو
            <ArrowLeft className="h-5 w-5" />
          </Button>
        </div>
      </div>

      {/* Main */}
      <div className="container-custom py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <LogoMark className="h-12 w-12 shadow-lg" />
            <div className="flex flex-col leading-none">
              <span className="font-display text-2xl text-white">الونا</span>
              <span className="text-xs text-secondary-300/80 tracking-widest mt-1.5">کلاس آموزش ناخن</span>
            </div>
          </div>
          <p className="text-gray-400 max-w-xs leading-8">
            کلاس آموزش تخصصی طراحی و کاشت ناخن برای تازه‌کارها؛ از اولین ضربهٔ قلم‌مو تا استقلال کامل، کنار الهام ابویی.
          </p>
        </div>

        <div>
          <h3 className="text-white font-medium mb-5 text-sm tracking-widest">دسترسی سریع</h3>
          <ul className="space-y-3.5">
            {quickLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href} className="text-gray-400 hover:text-secondary-200 transition-colors">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-white font-medium mb-5 text-sm tracking-widest">ارتباط</h3>
          <ul className="space-y-3.5 text-gray-400">
            <li>
              <a href="tel:09139079448" className="flex items-center gap-2.5 hover:text-secondary-200 transition-colors">
                <Phone className="h-4 w-4" /> ۰۹۱۳۹۰۷۹۴۴۸
              </a>
            </li>
            <li className="flex items-center gap-2.5">
              <MapPin className="h-4 w-4" /> یزد، مهریز
            </li>
            <li>
              <a href="#" className="flex items-center gap-2.5 hover:text-secondary-200 transition-colors">
                <Instagram className="h-4 w-4" /> اینستاگرام الونا
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-gray-500">
          <span>© {new Date().getFullYear()} الونا — الهام ابویی</span>
          <span className="tracking-widest text-xs">ELONA NAIL CLASS · YAZD</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
